import React, { useEffect, useState } from "react";
import Header from "components/Headers/Header";
import { Container, Row } from "reactstrap";
import mementosWelcomeImage from "../assets/img/custom/momentocard_preview.png";
import WelcomeScreen from "components/WelcomeScreen";
import { useSelector } from "react-redux";

const AddMementos = () => {
  const { uid } = useSelector((state) => state.auth);
  const [handleContinue, setHandleContinue] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const momentosBadgesContent = () => {
    return (
      <>
        <div className="border border-dark">
          <h1
            className="font-weight-bolder text-center"
            style={{ fontSize: isSmallScreen ? "13px" : "26px" }}
          >
            MEMENTOS – ATHLETE TIPS
          </h1>
        </div>
        <p className="font-weight-normal mt-2">
          <b className="text-danger">You can BE CREATIVE IN MAKING&nbsp;</b>
          <b className="text-primary">MEMENTOS&nbsp;</b>You choose which videos
          link to the QR codes. You choose the photos. Your fans might REQUEST
          A&nbsp;
          <b className="text-danger">
            CUSTOM MEMENTO FROM YOU. CHECK OUT THE VIDEO.
          </b>
        </p>
        <p className="font-weight-normal mt-2">
          Mementos at&nbsp;
          <b className="text-dark ">
            <b className="text-dark">Fans</b>
            <b className="text-primary">Help</b>
            <b className="text-danger">Players</b>
          </b>{" "}
          are PREPARED BY THE STUDENT ATHLETE OF FAN’S CHOICE. IF ATHLETE’S
          SCHOOL HAS SIGNED AN IP AGREEMENT WITH FHP, ATHLETE CAN USE FOOTAGE
          FROM SCHOOL FILES. ​&nbsp; &nbsp;
        </p>

        <p className="font-weight-normal mt-2">
          HERE’S another important thing to Remember– up to{" "}
          <b className="text-dark ">
            <b className="text-danger">88%</b> of the money{" "}
            <b className="text-dark">F</b>
            <b className="text-primary">H</b>
            <b className="text-danger">P</b> spend at FHP goes{" "}
            <b className="text-danger">
              <u> directly to Student Athletes.</u>
            </b>
          </b>
        </p>
        <p className="font-weight-normal mt-2">
          <b className="text-dark">THANK YOU!</b>{" "}
          <u className="text-dark">Enjoy</u> and{" "}
          <b className="text-dark">
            <u>TELL YOUR FRIENDS.</u>
          </b>
        </p>
      </>
    );
  };

  const youtubeLink = "https://www.youtube.com/watch?v=HQsfsy2Sonc";

  useEffect(() => {
    if (handleContinue) {
      window.open(
        `https://momento-platform.web.app/auth/login?redirect=/main/create-momentos/&athleteId=${uid}`,
        "_blank"
      );
    }
  }, [handleContinue]);
  return (
    <>
      <Header />
      <Container>
        <Row>
          <WelcomeScreen
            setHandleContinue={setHandleContinue}
            content={momentosBadgesContent}
            welcomeImage={mementosWelcomeImage}
            youtubeLink={youtubeLink}
          />
        </Row>
      </Container>
    </>
  );
};

export default AddMementos;
